import { createSlice } from "@reduxjs/toolkit";
import { addConfirm, removeConfirm } from "../utilities/windowConfirm";
import { DeleteWorkflowInStorage } from "./workflowSlice";

export interface iTabs {
    tabs: Array<iTabRow>;
}
export interface iTabRow {
    key: number;
    label: string;
    enquiryId?: number;
    active: boolean;
    onclick?: () => void;
}

const closeAll = (tabs: Array<iTabRow>) => {
    let testA: Array<iTabRow> = tabs.map(x => {
        x.active = false;

        return x;
    });

    return testA;
};

const initialState: iTabs = {
    tabs: [
        {
            key: 0,
            label: "",
            enquiryId: 10.35,
            active: true,
        },
    ],
};
export const tabRowSlice = createSlice({
    name: "tabRow",
    initialState,
    reducers: {
        setTabVisibility: (state, action) => {
            state.tabs = closeAll(state.tabs);
            let newArray = [...state.tabs];
            if (newArray.findIndex(i => i.key == action.payload) > -1) {
                newArray[newArray.findIndex(i => i.key == action.payload)].active = true;
            }
            state.tabs = newArray;
        },
        addTab: (state, action) => {
            state.tabs = closeAll(state.tabs);
            let newArray = [...state.tabs];
            if (newArray.findIndex(i => i.key == action.payload.key) > -1) {
                newArray[newArray.findIndex(i => i.key == action.payload.key)].active = true;
            } else {
                if (action.payload.key == 1001) {
                    newArray.splice(1, 0, action.payload);
                } else {
                    newArray.push(action.payload);
                }
            }
            state.tabs = newArray;
            if (state.tabs.length > 1) {
                addConfirm();
            }
        },
        removeTab: (state, action) => {
            let activeTabIndex = state.tabs.findIndex(i => i.active == true);
            let newArray = [...state.tabs];
            if (newArray.length === 0) {
                return;
            }
            if (newArray[activeTabIndex].key == action.payload) {
                //means the tab is being closed is the same one that is active.
                newArray = closeAll(state.tabs).filter(x => x.key != action.payload);
                if (newArray.length > 0) {
                    newArray[0].active = true;
                }
            } else {
                newArray = newArray.filter(x => x.key != action.payload);
            }
            state.tabs = newArray;
            DeleteWorkflowInStorage(action.payload);
            if (state.tabs.length <= 1) {
                removeConfirm();
            }
        },
        switchFirstTab: (state, action) => {
            state.tabs = closeAll(state.tabs);
            let newArray = [...state.tabs];
            if (newArray.findIndex(x => x.enquiryId == 10.35) > -1) {
                newArray[newArray.findIndex(x => x.enquiryId == 10.35)].label = action.payload;
                newArray[newArray.findIndex(x => x.enquiryId == 10.35)].active = true;
            } else {
                let fTab: iTabRow = {
                    key: 10.35,
                    label: action.payload,
                    enquiryId: 10.35,
                    active: true,
                };
                newArray.splice(0, 0, fTab);
            }

            state.tabs = newArray;
        },
        removeFirstTab: state => {
            let newArray = [...state.tabs];
            newArray = newArray.filter(x => x.enquiryId != 10.35);
            state.tabs = newArray;
        },
        // ,
        // activateQueues: (state, action) => {

        // }
    },
});

// Action creators are generated for each case reducer function
export const { setTabVisibility, addTab, removeTab, switchFirstTab, removeFirstTab } = tabRowSlice.actions;

export default tabRowSlice;
